import { useState } from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Header from "../../../components/Header";

const FAQ_DATA = [
  {
    question: "What are the check-in and check-out times?",
    answer:
      "Check-in is at 2:00 PM and check-out is at 11:00 AM. Early check-in or late check-out may be available upon request and subject to availability.",
  },
  {
    question: "Are pets allowed in the villas?",
    answer:
      "No, we have a strict no-pet policy to ensure the comfort and safety of all our guests.",
  },
  {
    question: "What amenities are included with the villa rental?",
    answer:
      "All our villas come with fully equipped kitchens, Wi-Fi, air conditioning, private pools & housekeeping services. Specific amenities vary by villa.",
  },
  {
    question: "Is there parking available?",
    answer:
      "Yes, all our villas provide free private parking for guests. The number of parking spaces varies by villa size.",
  },
  {
    question: "Can you arrange airport transfers?",
    answer:
      "Absolutely! We can arrange convenient airport transfers for an additional fee. Please contact us at least 24 hours before your arrival.",
  },
  {
    question: "What is your cancellation policy?",
    answer:
      "We offer a full refund upto 15 days before check in. Cancellations made within 15 days of check-in are non-refundable.",
  },
  {
    question: "Are the villas suitable for events or parties?",
    answer:
      "Our villas are perfect for intimate celebrations and small gatherings. Please inform us in advance about any events. Loud parties are not permitted to respect our neighbors.",
  },
  {
    question: "Do you offer guest laundry services?",
    answer: "No, we do not offer guest laundry services at this time.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit cards, bank transfers, and digital payment methods. A security deposit may be required upon check-in.",
  },
];

export default function FAQ() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box maxWidth={1000} mx="auto" my={12} px={{ xs: 2, sm: 4 }}>
      <Header label="FAQ" title="Frequently Asked Questions" />

      <Box mt={6} pb={{ xs: 4, sm: 8 }}>
        {FAQ_DATA.map((faq, idx) => (
          <Box data-aos="fade-up" data-aos-delay={idx * 100} mb={2}>
            <Accordion
              key={idx}
              expanded={expanded === `panel${idx}`}
              onChange={handleChange(`panel${idx}`)}
              sx={{
                p: 3,
                border: "1px solid #ffffff20",
                borderRadius: "24px !important",
                bgcolor: "transparent",
                "&:before": {
                  display: "none",
                },
                "&.Mui-expanded": {
                  margin: "0 0 16px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: "accent.main" }} />}
                sx={{
                  borderRadius: "12px",
                  "&.Mui-expanded": {
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                }}
              >
                <Typography variant="h6" typography={{ xs: "body1", sm: "h6" }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  pt: 3,
                }}
              >
                <Typography color="text.secondary" lineHeight={1.7}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
